export default __webpack_public_path__ + "static/media/EducationWeek.96a13561.svg";